import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import SnackbarProvider from "./components/snackbar/SnackbarProvider";

import {
    initAnalyticsFromApi,
    initMetricTracker,
    refreshEnabledMetrics,
} from "@ecommerce/analytics";
import { httpClient, restoreStorefrontSession } from "./http";
import { cargarEstilos } from "./util/estilos/cargarEstilos";
import { configureStorefrontCart } from "./cart/configureStorefrontCart";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

(async () => {
    configureStorefrontCart();
    await cargarEstilos();
    await restoreStorefrontSession();

    root.render(
        <React.StrictMode>
            <SnackbarProvider>
                <App />
            </SnackbarProvider>
        </React.StrictMode>,
    );

    void initAnalyticsFromApi(httpClient);
    void initMetricTracker(httpClient);

    const refreshMetricsWhenReturning = () => {
        if (document.visibilityState === "visible") void refreshEnabledMetrics();
    };

    window.addEventListener("focus", refreshMetricsWhenReturning);
    document.addEventListener("visibilitychange", refreshMetricsWhenReturning);
})();
